import PropTypes from 'prop-types';
import React from 'react';
import UserDetailsRow from 'components/users/UserDetailsRow';
import UserDetailsElement from 'components/users/UserDetailsElement';

const InstallerCertificationsDetails = ({ installer }) => {
  const {
    installer_firm_certification_number = null,
    installer_firm_certification_expiration = null,
    assigned_renovator_certification_number = null,
    assigned_renovator_certification_expiration = null,
  } = installer;

  return (
    <div>
      <UserDetailsRow title="Millwork certifications">
        <UserDetailsElement
          title="installer firm certification number"
          value={installer_firm_certification_number || '—'}
        />
        <UserDetailsElement
          title="installer firm certification expiration"
          value={installer_firm_certification_expiration || '—'}
        />
        <UserDetailsElement
          title="assigned renovator certification number"
          value={assigned_renovator_certification_number || '—'}
        />
        <UserDetailsElement
          title="assigned renovator certification expiration"
          value={assigned_renovator_certification_expiration || '—'}
        />
      </UserDetailsRow>
    </div>
  );
};

InstallerCertificationsDetails.propTypes = {
  installer: PropTypes.object.isRequired,
};

export default InstallerCertificationsDetails;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerCertificationsDetails.jsx